// extracted by mini-css-extract-plugin
export default {"button":"SecondaryButton_button__SIL9T","light":"SecondaryButton_light__d252t"};